import {
  fromUnixTime,
  getUnixTime,
  millisecondsToSeconds,
  secondsToMilliseconds,
} from 'date-fns';

export const parseEsriDate = (value: string | number | undefined): Date => {
  if (!value || value === '') {
    return new Date();
  }
  return fromUnixTime(millisecondsToSeconds(Number(value)));
};

export const formatEsriDate = (value: Date | undefined): string => {
  if (!value) {
    return '';
  }
  return secondsToMilliseconds(getUnixTime(value)).toString();
};
